(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 8193:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./src/components/Page/index.ts + 18 modules
var Page = __webpack_require__(9025);
// EXTERNAL MODULE: ./src/components/PageTemplate/index.ts + 3 modules
var PageTemplate = __webpack_require__(1115);
// EXTERNAL MODULE: ./src/hooks/useModal.tsx
var useModal = __webpack_require__(2022);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(5235);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(3091);
;// CONCATENATED MODULE: ./src/utils/format.ts
var FormatType;

(function (FormatType) {
  FormatType[FormatType["AMERICA"] = 0] = "AMERICA";
})(FormatType || (FormatType = {}));

var formatPhoneNumber = function formatPhoneNumber(value) {
  // if input value is falsy eg if the user deletes the input, then just return
  if (!value) return value; // clean the input for any non-digit values.

  var phoneNumber = value.replace(/[^\d]/g, ""); // phoneNumberLength is used to know when to apply our formatting for the phone number

  var phoneNumberLength = phoneNumber.length; // we need to return the value with no formatting if its less then four digits
  // this is to avoid weird behavior that occurs if you  format the area code to early

  if (phoneNumberLength < 4) return phoneNumber; // if phoneNumberLength is greater than 4 and less the 7 we start to return
  // the formatted number

  if (phoneNumberLength < 7) {
    return "(".concat(phoneNumber.slice(0, 3), ") ").concat(phoneNumber.slice(3));
  } // finally, if the phoneNumberLength is greater then seven, we add the last
  // bit of formatting and return it.


  return "(".concat(phoneNumber.slice(0, 3), ") ").concat(phoneNumber.slice(3, 6), "-").concat(phoneNumber.slice(6, 10));
};
var formatPhoneNumberWithType = function formatPhoneNumberWithType(phoneNumber, format) {
  switch (format) {
    case FormatType.AMERICA:
      return "+1".concat(phoneNumber.replace(/[^0-9]/g, ""));

    default:
      throw new Error("Invalid format type");
  }
};
var formatCurrency = function formatCurrency(value) {
  return "$ " + value.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, " ");
};
// EXTERNAL MODULE: ../../packages/ui/components/Typography/Heading/index.ts + 9 modules
var Heading = __webpack_require__(3212);
// EXTERNAL MODULE: ../../packages/ui/components/Typography/Text/index.ts + 6 modules
var Text = __webpack_require__(4683);
;// CONCATENATED MODULE: ./src/widgets/home/SocialProofs/components/index.tsx



var Wrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "components__Wrapper",
  componentId: "sc-vi5dy5-0"
})(["background-color:", ";border-radius:32px;padding:32px 48px;@media (max-width:", "){padding:24px;}"], function (_ref) {
  var theme = _ref.theme;
  return theme.palette.black.tint;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.tablet;
});
var Caption = (0,styled_components_browser_esm["default"])(Text/* Caption */.YS).withConfig({
  displayName: "components__Caption",
  componentId: "sc-vi5dy5-1"
})(["color:", ";margin-bottom:8px;"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.palette.white.main + theme.opacity.half;
});
var H3 = (0,styled_components_browser_esm["default"])(Heading.H3).withConfig({
  displayName: "components__H3",
  componentId: "sc-vi5dy5-2"
})(["font-family:", ";font-weight:700;"], function (_ref4) {
  var theme = _ref4.theme;
  return theme.fonts.secondary;
});
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2322);
;// CONCATENATED MODULE: ./src/widgets/home/SocialProofs/components/SocialProof.tsx





var SocialProof = function SocialProof(_ref) {
  var title = _ref.title,
      value = _ref.value;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Wrapper, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Caption, {
      children: title
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(H3, {
      children: value
    })]
  });
};

/* harmony default export */ var components_SocialProof = (SocialProof);
;// CONCATENATED MODULE: ./src/widgets/home/SocialProofs/SocialProofs.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






var SocialProofs_Wrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "SocialProofs__Wrapper",
  componentId: "sc-5sugxt-0"
})(["width:100%;display:grid;grid-auto-flow:column;grid-gap:48px;margin-bottom:48px;@media (max-width:", "){grid-auto-flow:row;grid-gap:20px;}"], function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoints.mobile;
});
var proofs = [{
  title: "Premiums Originated",
  value: formatCurrency(100000)
}, {
  title: "Earned Programs",
  value: formatCurrency(100000)
}, {
  title: "Total Programs",
  value: "100"
}];

var SocialProofs = function SocialProofs() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(SocialProofs_Wrapper, {
    children: proofs.map(function (proof, index) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(components_SocialProof, _objectSpread({}, proof), index);
    })
  });
};

/* harmony default export */ var SocialProofs_SocialProofs = (SocialProofs);
;// CONCATENATED MODULE: ./src/widgets/home/SocialProofs/index.ts

// EXTERNAL MODULE: ../../packages/ui/index.ts + 101 modules
var ui = __webpack_require__(6226);
;// CONCATENATED MODULE: ./src/widgets/home/Tracker/components/index.tsx




var components_Wrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "components__Wrapper",
  componentId: "sc-1xjllj2-0"
})(["margin-bottom:48px;"]);
var Header = styled_components_browser_esm["default"].header.withConfig({
  displayName: "components__Header",
  componentId: "sc-1xjllj2-1"
})(["display:grid;grid-auto-flow:column;justify-content:space-between;align-items:center;margin-bottom:48px;@media (max-width:", "){grid-auto-flow:row;align-items:start;grid-gap:16px;margin-bottom:24px;}"], function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoints.mobile;
});
var Title = (0,styled_components_browser_esm["default"])(Heading.H1).withConfig({
  displayName: "components__Title",
  componentId: "sc-1xjllj2-2"
})(["font-family:", ";font-weight:700;@media (max-width:", "){font-size:48px;line-height:56px;}"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.fonts.secondary;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoints.mobile;
});
var H2 = (0,styled_components_browser_esm["default"])(Heading.H2).withConfig({
  displayName: "components__H2",
  componentId: "sc-1xjllj2-3"
})(["font-family:", ";font-weight:700;"], function (_ref4) {
  var theme = _ref4.theme;
  return theme.fonts.secondary;
});
var SegmentedControl = (0,styled_components_browser_esm["default"])(ui/* SegmentedControl */.sY).withConfig({
  displayName: "components__SegmentedControl",
  componentId: "sc-1xjllj2-4"
})(["min-width:320px;"]);
var ChartWrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "components__ChartWrapper",
  componentId: "sc-1xjllj2-5"
})(["max-width:100%;padding:24px;border-radius:24px;background-color:", ";"], function (_ref5) {
  var theme = _ref5.theme;
  return theme.palette.black.tint;
});
var components_Caption = (0,styled_components_browser_esm["default"])(Text/* Caption */.YS).withConfig({
  displayName: "components__Caption",
  componentId: "sc-1xjllj2-6"
})(["color:", ";margin-bottom:8px;"], function (_ref6) {
  var theme = _ref6.theme;
  return theme.palette.white.main + theme.opacity.half;
});
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 5 modules
var slicedToArray = __webpack_require__(7113);
// EXTERNAL MODULE: ../../node_modules/chart.js/auto/auto.esm.js
var auto_esm = __webpack_require__(7289);
// EXTERNAL MODULE: ../../node_modules/chartjs-plugin-datalabels/dist/chartjs-plugin-datalabels.esm.js + 2 modules
var chartjs_plugin_datalabels_esm = __webpack_require__(9663);
// EXTERNAL MODULE: ../../node_modules/react-chartjs-2/dist/index.js
var dist = __webpack_require__(9309);
// EXTERNAL MODULE: ../../node_modules/react-responsive/dist/react-responsive.js
var react_responsive = __webpack_require__(715);
// EXTERNAL MODULE: ../../packages/ui/ThemeProvider.tsx + 1 modules
var ThemeProvider = __webpack_require__(1993);
;// CONCATENATED MODULE: ./src/widgets/home/Tracker/components/BarChart.tsx









auto_esm/* default.register */.Z.register();

var BarChart = function BarChart() {
  var theme = (0,ThemeProvider/* useTheme */.F)();

  var _React$useState = react.useState(520 / 392),
      _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
      aspectRatio = _React$useState2[0],
      setAspectRatio = _React$useState2[1];

  var isMobile = (0,react_responsive.useMediaQuery)({
    maxWidth: theme.breakpoints.mobile
  });
  var isTablet = (0,react_responsive.useMediaQuery)({
    maxWidth: theme.breakpoints.tablet
  });
  react.useEffect(function () {
    if (isMobile) {
      setAspectRatio(272 / 312);
    } else if (isTablet) {
      setAspectRatio(680 / 312);
    } else {
      setAspectRatio(520 / 392);
    }
  }, [isMobile, isTablet]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(dist/* Bar */.$Q, {
    className: "chart",
    data: {
      labels: [" "],
      datasets: [{
        label: "In progress",
        data: [19700],
        backgroundColor: function backgroundColor(context) {
          var _context$chart = context.chart,
              ctx = _context$chart.ctx,
              y = _context$chart.scales.y,
              datasets = _context$chart.data.datasets,
              chartArea = _context$chart.chartArea;
          if (!chartArea) return;
          var gradient = ctx.createLinearGradient(0, y.getPixelForValue(datasets[0].data[0]), 0, y.getPixelForValue(0));
          gradient.addColorStop(0, theme.palette.white.main + theme.opacity.half);
          gradient.addColorStop(1, theme.palette.white.main + theme.opacity.none);
          return gradient;
        },
        borderColor: theme.palette.white.main,
        borderWidth: {
          top: 2,
          right: 0,
          bottom: 0,
          left: 0
        },
        datalabels: {
          color: theme.palette.white.main,
          font: [{
            family: theme.fonts.secondary,
            weight: 700,
            size: 24
          }],
          formatter: formatCurrency
        },
        barPercentage: 1,
        categoryPercentage: 1
      }, {
        label: "Mature",
        data: [40800],
        backgroundColor: function backgroundColor(context) {
          var _context$chart2 = context.chart,
              y = _context$chart2.scales.y,
              ctx = _context$chart2.ctx,
              datasets = _context$chart2.data.datasets,
              chartArea = _context$chart2.chartArea;
          if (!chartArea) return;
          var gradient = ctx.createLinearGradient(0, 0, 0, y.getPixelForValue(datasets[0].data[0]));
          gradient.addColorStop(0, theme.palette.blue.main + theme.opacity.half);
          gradient.addColorStop(1, theme.palette.blue.main + theme.opacity.none);
          return gradient;
        },
        borderWidth: {
          top: 2,
          right: 0,
          bottom: 0,
          left: 0
        },
        borderColor: theme.palette.blue.main,
        datalabels: {
          color: theme.palette.white.main,
          font: [{
            family: theme.fonts.secondary,
            weight: 700,
            size: 24
          }],
          formatter: formatCurrency
        },
        barPercentage: 1,
        categoryPercentage: 1
      }]
    },
    options: {
      responsive: true,
      aspectRatio: aspectRatio,
      scales: {
        x: {
          stacked: true,
          grid: {
            display: false,
            drawBorder: false,
            drawOnChartArea: false,
            drawTicks: false
          }
        },
        y: {
          stacked: true,
          grid: {
            display: false,
            drawBorder: false,
            drawOnChartArea: false,
            drawTicks: false
          },
          ticks: {
            display: false
          }
        }
      },
      plugins: {
        legend: {
          reverse: true,
          position: "bottom",
          align: "start",
          labels: {
            usePointStyle: true,
            pointStyle: "circle",
            color: theme.palette.white.main,
            boxWidth: 6,
            boxHeight: 6
          }
        },
        tooltip: {
          enabled: false
        }
      }
    },
    plugins: [chartjs_plugin_datalabels_esm/* default */.Z]
  });
};

/* harmony default export */ var components_BarChart = (BarChart);
;// CONCATENATED MODULE: ./src/widgets/home/Tracker/utils/chartHelpers.ts
function generateGradient(context, arrowDirection, theme) {
  var chart = context.chart;
  if (!chart.chartArea) return;
  return getGradient(chart, theme, arrowDirection);
}

function getGradient(_ref, theme) {
  var ctx = _ref.ctx,
      chartArea = _ref.chartArea;
  var direction = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "up";
  var color = direction === "up" ? theme.palette.mint.main : theme.palette.red.main;
  var height = chartArea.height;
  var gradient = ctx.createLinearGradient(0, 0, 0, height);
  gradient.addColorStop(0, color + theme.opacity.half);
  gradient.addColorStop(1, color + theme.opacity.none);
  return gradient;
}
;// CONCATENATED MODULE: ./src/widgets/home/Tracker/components/SteppedLineChart.tsx











var Value = styled_components_browser_esm["default"].div.withConfig({
  displayName: "SteppedLineChart__Value",
  componentId: "sc-jytfp7-0"
})(["display:grid;grid-auto-flow:column;grid-gap:16px;align-items:baseline;margin-bottom:32px;width:min-content;color:", ";div{width:32px;height:32px;display:grid;place-items:center;background-color:", ";border-radius:32px;}svg{path,g{stroke:currentColor;}}"], function (_ref) {
  var theme = _ref.theme,
      direction = _ref.direction;
  return direction === "up" ? theme.palette.mint.main : theme.palette.red.main;
}, function (_ref2) {
  var theme = _ref2.theme,
      direction = _ref2.direction;
  return (direction === "up" ? theme.palette.mint.main : theme.palette.red.main) + theme.opacity.dark;
});

var SteppedLineChart = function SteppedLineChart(_ref3) {
  var caption = _ref3.caption,
      arrowDirection = _ref3.arrowDirection,
      value = _ref3.value;
  var theme = (0,ThemeProvider/* useTheme */.F)();

  var _React$useState = react.useState(536 / 120),
      _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
      aspectRatio = _React$useState2[0],
      setAspectRatio = _React$useState2[1];

  var isMobile = (0,react_responsive.useMediaQuery)({
    maxWidth: theme.breakpoints.mobile
  });
  var isTablet = (0,react_responsive.useMediaQuery)({
    maxWidth: theme.breakpoints.tablet
  });
  react.useEffect(function () {
    if (isMobile) {
      setAspectRatio(272 / 120);
    } else if (isTablet) {
      setAspectRatio(680 / 120);
    } else {
      setAspectRatio(536 / 120);
    }
  }, [isMobile, isTablet]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components_Caption, {
      children: caption
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Value, {
      direction: arrowDirection,
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(H2, {
        children: [value, "%"]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        children: arrowDirection === "up" ? /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* ArrowUp */.a2, {}) : /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* ArrowDown */.K5, {})
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(dist/* Line */.x1, {
      className: "chart",
      data: {
        labels: ["January", "February", "March", "April", "May", "June", "July"],
        datasets: [{
          label: "Filled",
          backgroundColor: function backgroundColor(context) {
            return generateGradient(context, arrowDirection, theme);
          },
          borderColor: arrowDirection === "up" ? theme.palette.mint.main : theme.palette.red.main,
          data: [40, 23, 12, 73, 56, 32, 12],
          fill: true,
          stepped: "before",
          pointRadius: 0
        }]
      },
      options: {
        responsive: true,
        aspectRatio: aspectRatio,
        scales: {
          x: {
            grid: {
              display: false,
              drawBorder: false,
              drawOnChartArea: false,
              drawTicks: false
            },
            ticks: {
              color: theme.palette.white.main,
              autoSkip: true,
              maxRotation: 0,
              minRotation: 0
            }
          },
          y: {
            grid: {
              display: false,
              drawBorder: false,
              drawOnChartArea: false,
              drawTicks: false
            },
            ticks: {
              display: false
            }
          }
        },
        plugins: {
          legend: {
            display: false
          }
        }
      }
    })]
  });
};

/* harmony default export */ var components_SteppedLineChart = (SteppedLineChart);
;// CONCATENATED MODULE: ./src/widgets/home/Tracker/components/BalanceChart.tsx







var BalanceChart_Wrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "BalanceChart__Wrapper",
  componentId: "sc-1lyxprp-0"
})(["display:grid;grid-template-columns:repeat(auto-fit,minmax(272px,1fr));grid-gap:32px;& > div,.chart{max-width:100%;}& > div:nth-child(2){display:grid;grid-template-rows:1fr 1fr;}@media (max-width:", "){grid-template-columns:1fr;grid-template-rows:1fr 1fr;grid-gap:20px;}"], function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoints.tablet;
});

var BalanceChart = function BalanceChart() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(BalanceChart_Wrapper, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components_Caption, {
        children: "Total investments"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(H2, {
        children: "$ 60\u2009500.00"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(components_BarChart, {})]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components_SteppedLineChart, {
        caption: "total APR",
        value: "35.5",
        arrowDirection: "down"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(components_SteppedLineChart, {
        caption: "APY",
        value: "0.85",
        arrowDirection: "up"
      })]
    })]
  });
};

/* harmony default export */ var components_BalanceChart = (BalanceChart);
;// CONCATENATED MODULE: ./src/widgets/home/Tracker/components/LineChart.tsx










var LineChart_Wrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "LineChart__Wrapper",
  componentId: "sc-t5258q-0"
})(["& > div,.chart{max-width:100%;}"]);

var LineChart = function LineChart() {
  var theme = (0,ThemeProvider/* useTheme */.F)();

  var _React$useState = react.useState(1104 / 392),
      _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
      aspectRatio = _React$useState2[0],
      setAspectRatio = _React$useState2[1];

  var isMobile = (0,react_responsive.useMediaQuery)({
    maxWidth: theme.breakpoints.mobile
  });
  var isTablet = (0,react_responsive.useMediaQuery)({
    maxWidth: theme.breakpoints.tablet
  });
  react.useEffect(function () {
    if (isMobile) {
      setAspectRatio(272 / 338);
    } else if (isTablet) {
      setAspectRatio(680 / 392);
    } else {
      setAspectRatio(1104 / 392);
    }
  }, [isMobile, isTablet]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(LineChart_Wrapper, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components_Caption, {
      children: "Premiums Originated"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(H2, {
      children: "$ 100\u2009000.00"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(dist/* Line */.x1, {
      className: "chart",
      data: {
        labels: ["January", "February", "March", "April", "May", "June", "July"],
        datasets: [{
          label: "Filled",
          backgroundColor: function backgroundColor(context) {
            return generateGradient(context, "up", theme);
          },
          borderColor: theme.palette.mint.main,
          data: [12, 12, 23, 32, 40, 56, 73],
          fill: true,
          pointRadius: 0
        }]
      },
      options: {
        responsive: true,
        aspectRatio: aspectRatio,
        scales: {
          x: {
            grid: {
              display: false,
              drawBorder: false,
              drawOnChartArea: false,
              drawTicks: false
            },
            ticks: {
              color: theme.palette.white.main
            }
          },
          y: {
            grid: {
              display: false,
              drawBorder: false,
              drawOnChartArea: false,
              drawTicks: false
            },
            ticks: {
              display: false
            }
          }
        },
        plugins: {
          legend: {
            display: false
          }
        }
      }
    })]
  });
};

/* harmony default export */ var components_LineChart = (LineChart);
;// CONCATENATED MODULE: ./src/widgets/home/Tracker/Tracker.tsx







var Tracker = function Tracker() {
  var _useState = (0,react.useState)("balance"),
      chartToShow = _useState[0],
      setChartToShow = _useState[1];

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(components_Wrapper, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Header, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title, {
        children: "Tracker"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(SegmentedControl, {
        tint: "blue",
        options: [{
          label: "Your balance",
          value: "balance"
        }, {
          label: "Total premiums",
          value: "premiums"
        }],
        name: "filter",
        value: chartToShow,
        onChange: function onChange(e) {
          return setChartToShow(e.target.value);
        }
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(ChartWrapper, {
      children: chartToShow === "balance" ? /*#__PURE__*/(0,jsx_runtime.jsx)(components_BalanceChart, {}) : /*#__PURE__*/(0,jsx_runtime.jsx)(components_LineChart, {})
    })]
  });
};

/* harmony default export */ var Tracker_Tracker = (Tracker);
;// CONCATENATED MODULE: ./src/widgets/home/Tracker/index.ts

// EXTERNAL MODULE: ../../packages/ui/components/Typography/Text/Body/styles.tsx
var styles = __webpack_require__(8428);
;// CONCATENATED MODULE: ./src/widgets/home/Vesting/components/index.tsx



var components_Title = (0,styled_components_browser_esm["default"])(Heading.H2).withConfig({
  displayName: "components__Title",
  componentId: "sc-18w3bsm-0"
})(["margin-bottom:40px;font-weight:700;"]);
var Thead = styled_components_browser_esm["default"].thead.withConfig({
  displayName: "components__Thead",
  componentId: "sc-18w3bsm-1"
})(["text-transform:uppercase;color:", ";border-bottom:1px solid ", ";th{font-weight:500;padding:32px 0;}"], function (_ref) {
  var theme = _ref.theme;
  return theme.palette.white.main + theme.opacity.half;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.palette.white.main + theme.opacity.dark;
});
var Tbody = styled_components_browser_esm["default"].tbody.withConfig({
  displayName: "components__Tbody",
  componentId: "sc-18w3bsm-2"
})(["", " td{border-bottom:1px solid ", ";padding:32px 0;}"], styles/* default */.Z, function (_ref3) {
  var theme = _ref3.theme;
  return theme.palette.white.main + theme.opacity.dark;
});
;// CONCATENATED MODULE: ./src/widgets/home/Vesting/components/Table.tsx






var Table_Wrapper = styled_components_browser_esm["default"].table.withConfig({
  displayName: "Table__Wrapper",
  componentId: "sc-fvmql2-0"
})(["text-align:left;border-collapse:collapse;width:100%;th,td{min-width:266.5px;}th:last-child,td:last-child{min-width:134px;}"]);

var Table = function Table() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Table_Wrapper, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Thead, {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("tr", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("th", {
          children: "Amount"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("th", {
          children: "Date"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("th", {
          children: "Vesting period"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("th", {})]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Tbody, {
      children: Array(5).fill(null).map(function (_, index) {
        return /*#__PURE__*/(0,jsx_runtime.jsxs)("tr", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("td", {
            children: "10\u2009000 USDC"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("td", {
            children: "Today"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("td", {
            children: "180 days"
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("td", {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ui/* ExternalLink */.dL, {}), " ", /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* MoreVertical */.hl, {})]
          })]
        }, index);
      })
    })]
  });
};

/* harmony default export */ var components_Table = (Table);
;// CONCATENATED MODULE: ./src/widgets/home/Vesting/Vesting.tsx







var Vesting_Wrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Vesting__Wrapper",
  componentId: "sc-5x08pe-0"
})(["max-width:100%;overflow-x:auto;margin-bottom:120px;"]);

var Vesting = function Vesting() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components_Title, {
      children: "Vesting history"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Vesting_Wrapper, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_Table, {})
    })]
  });
};

/* harmony default export */ var Vesting_Vesting = (Vesting);
;// CONCATENATED MODULE: ./src/widgets/home/Vesting/index.ts

;// CONCATENATED MODULE: ./src/pages/index.tsx










var DashboardPage = function DashboardPage() {
  var modal = (0,useModal/* useModal */.dd)();
  (0,react.useEffect)(modal.closeModal, []);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Page/* Page */.T, {
    title: "Dashboard",
    description: "Dashboard",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(PageTemplate/* DashboardPageTemplate */.A, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Tracker_Tracker, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(SocialProofs_SocialProofs, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(Vesting_Vesting, {})]
    })
  });
};

/* harmony default export */ var pages = (DashboardPage);

/***/ }),

/***/ 7314:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(8193);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [651,577,495,565,63,774,888,179], function() { return __webpack_exec__(7314); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);